import { render, staticRenderFns } from "./ColdEvaluationPage.vue?vue&type=template&id=038c26b3&"
import script from "./ColdEvaluationPage.vue?vue&type=script&lang=js&"
export * from "./ColdEvaluationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports